import { Heading, Stack } from '@chakra-ui/react';

import { CargoPlane } from '../../components/CargoPlane';
import { Page } from '../../components/Page';
import { useCustomerCopy } from '../../hooks/tenant/useCustomerCopy';

export const NotFound = () => {
  const copy = useCustomerCopy();

  return (
    <Page title="404 Not Found" flex="1" position="relative">
      <Stack align="center" justify="center">
        <Heading variant="h2" mt="30vh" textAlign="center">
          {copy('notFound.heading')}
        </Heading>
        <CargoPlane maxW="800px" />
      </Stack>
    </Page>
  );
};
